module.exports = __webpack_public_path__ + "../resources/img/ic_download.65d8b855.svg";